/**
 * Command identifiers aligned with `PowerEditor/src/menuCmdID.h` names from
 * PROJECT_SOURCE_CODE_DESCRIPTION.md (subset for WEB shell; extend as features land).
 */
export const CMD = {
  // File
  FILE_NEW: "IDM_FILE_NEW",
  FILE_OPEN: "IDM_FILE_OPEN",
  /** WEB: folder as workspace (File System Access `showDirectoryPicker`). */
  FILE_OPEN_FOLDER: "WEB_FILE_OPEN_FOLDER",
  /** WEB: fetch an HTML page by URL into a new editable tab (CORS permitting). */
  FILE_OPEN_HTML_URL: "WEB_FILE_OPEN_HTML_URL",
  FILE_CLOSE: "IDM_FILE_CLOSE",
  FILE_CLOSEALL: "IDM_FILE_CLOSEALL",
  FILE_SAVE: "IDM_FILE_SAVE",
  FILE_SAVEAS: "IDM_FILE_SAVEAS",
  FILE_SAVEALL: "IDM_FILE_SAVEALL",
  FILE_PRINT: "IDM_FILE_PRINT",
  /** WEB: list paths from localStorage (browser cannot reopen arbitrary paths). */
  FILE_RECENTFILES: "WEB_FILE_RECENTFILES_LIST",
  /** WEB: MRU slot 0 (most recent) … see `FILE_RECENT_SLOT_IDS`. */
  FILE_RECENT_0: "WEB_FILE_RECENT_0",
  FILE_RECENT_1: "WEB_FILE_RECENT_1",
  FILE_RECENT_2: "WEB_FILE_RECENT_2",
  FILE_RECENT_3: "WEB_FILE_RECENT_3",
  FILE_RECENT_4: "WEB_FILE_RECENT_4",
  FILE_RECENT_5: "WEB_FILE_RECENT_5",
  FILE_RECENT_6: "WEB_FILE_RECENT_6",
  FILE_RECENT_7: "WEB_FILE_RECENT_7",
  FILE_RECENT_8: "WEB_FILE_RECENT_8",
  FILE_RECENT_9: "WEB_FILE_RECENT_9",
  FILE_RECENT_CLEAR: "WEB_FILE_RECENT_CLEAR",
  FILE_RECENT_EMPTY: "WEB_FILE_RECENT_EMPTY",
  /** WEB: copy saved path or tab title to clipboard. */
  FILE_COPY_PATH: "WEB_FILE_COPY_PATH",
  /** WEB: share active text or Max (.max) tab buffer to another NullaPad (recipient secret); legacy video viewMode still allowed in shell. */
  FILE_SHARE_NULLAPAD: "WEB_FILE_SHARE_NULLAPAD",
  /** WEB: open print dialog for rendered preview / compare / syntax (Save as PDF in browser). */
  EXPORT_TO_PDF: "WEB_EXPORT_TO_PDF",
  /** WEB: in Max tabs, export rendered `@@...@@` result as Markdown `.md`. */
  EXPORT_MAX_RENDERED_MD: "WEB_EXPORT_MAX_RENDERED_MD",
  FILE_EXIT: "IDM_FILE_EXIT",
  /** WEB: record a new .nulla webcam video. */
  FILE_RECORD_NULLA: "WEB_FILE_RECORD_NULLA",
  /** WEB: same as toolbar mic in a Nulla video tab (last clip); kept for programmatic / future shortcut use. */
  FILE_NULLA_MIC_INJECT: "WEB_FILE_NULLA_MIC_INJECT",
  // View Examples
  /** WEB: open Quick Start MAX example in a new tab. */
  EXAMPLE_QUICK_START: "WEB_VIEW_EXAMPLE_QUICK_START",
  /** WEB: open Showcase MAX example in a new tab. */
  EXAMPLE_SHOWCASE: "WEB_VIEW_EXAMPLE_SHOWCASE",
  /** WEB: open Math Paper MAX example in a new tab. */
  EXAMPLE_MATH_PAPER: "WEB_VIEW_EXAMPLE_MATH_PAPER",
  // Edit
  EDIT_UNDO: "IDM_EDIT_UNDO",
  EDIT_REDO: "IDM_EDIT_REDO",
  EDIT_CUT: "IDM_EDIT_CUT",
  EDIT_COPY: "IDM_EDIT_COPY",
  EDIT_PASTE: "IDM_EDIT_PASTE",
  EDIT_DELETE: "IDM_EDIT_DELETE",
  EDIT_SELECTALL: "IDM_EDIT_SELECTALL",
  EDIT_UPPERCASE: "IDM_EDIT_UPPERCASE",
  EDIT_LOWERCASE: "IDM_EDIT_LOWERCASE",
  EDIT_DUPLICATE_LINE: "IDM_EDIT_DUPLICATE_CURRENT_LINE",
  EDIT_TRIM_TRAILING: "IDM_EDIT_TRIMTRAILING",
  EDIT_INSERT_DATETIME: "IDM_EDIT_INSERT_DATETIME",
  EDIT_LINE_UP: "IDM_EDIT_MOVE_UP_CURRENT_LINE",
  EDIT_LINE_DOWN: "IDM_EDIT_MOVE_DOWN_CURRENT_LINE",
  EDIT_JOIN_LINES: "WEB_EDIT_JOIN_LINES",
  EDIT_REMOVE_EMPTY_LINES: "WEB_EDIT_REMOVE_EMPTY_LINES",
  EDIT_SORT_LINES: "WEB_EDIT_SORT_LINES",
  EDIT_INDENT_INCREASE: "WEB_EDIT_INDENT_INC",
  EDIT_INDENT_DECREASE: "WEB_EDIT_INDENT_DEC",
  // Search
  SEARCH_FIND: "IDM_SEARCH_FIND",
  SEARCH_REPLACE: "IDM_SEARCH_REPLACE",
  SEARCH_FINDINFILES: "IDM_SEARCH_FINDINFILES",
  SEARCH_FINDINDIRECTORY: "WEB_SEARCH_FINDINDIRECTORY",
  SEARCH_GOTOLINE: "IDM_SEARCH_GOTOLINE",
  SEARCH_FINDNEXT: "IDM_SEARCH_FINDNEXT",
  SEARCH_FINDPREV: "IDM_SEARCH_FINDPREVIOUS",
  SEARCH_SETANDFINDNEXT: "IDM_SEARCH_SETANDFINDNEXT",
  SEARCH_SETANDFINDPREV: "IDM_SEARCH_SETANDFINDPREV",
  SEARCH_VOLATILE_FINDNEXT: "IDM_SEARCH_VOLATILE_FINDNEXT",
  SEARCH_VOLATILE_FINDPREV: "IDM_SEARCH_VOLATILE_FINDPREV",
  SEARCH_FINDINCREMENT: "IDM_SEARCH_FINDINCREMENT",
  SEARCH_GOTOMATCHINGBRACE: "IDM_SEARCH_GOTOMATCHINGBRACE",
  /** WEB: count matches for find string (uses Find session). */
  SEARCH_COUNT: "WEB_SEARCH_COUNT",
  // View
  VIEW_WRAP: "IDM_VIEW_WRAP",
  VIEW_LINENUMBER: "WEB_VIEW_LINENUMBER",
  VIEW_ZOOMIN: "IDM_VIEW_ZOOMIN",
  VIEW_ZOOMOUT: "IDM_VIEW_ZOOMOUT",
  VIEW_ZOOMRESTORE: "IDM_VIEW_ZOOMRESTORE",
  VIEW_FULLSCREEN: "IDM_VIEW_FULLSCREENTOGGLE",
  /** WEB: side-by-side text editors for two tabs (toolbar + View menu). */
  VIEW_MULTIVIEW: "WEB_VIEW_MULTIVIEW",
  /** WEB: exit multiview (one editor + previews restored). */
  VIEW_SINGLE_EDITOR: "WEB_VIEW_SINGLE_EDITOR",
  /** WEB: show bottom Git terminal (isomorphic-git on folder workspace). */
  VIEW_GIT_TERMINAL: "WEB_VIEW_GIT_TERMINAL",
  // Encoding / Format (EOL + charset — same top menu as desktop “Encoding”)
  FORMAT_TODOS: "IDM_FORMAT_TODOS",
  FORMAT_TOUNIX: "IDM_FORMAT_TOUNIX",
  FORMAT_TOMAC: "IDM_FORMAT_TOMAC",
  FORMAT_UTF_8: "IDM_FORMAT_UTF_8",
  FORMAT_ANSI: "IDM_FORMAT_ANSI",
  // Language (subset of menuCmdID.h language IDs)
  LANG_TEXT: "IDM_LANG_TEXT",
  LANG_C: "IDM_LANG_C",
  LANG_CPP: "IDM_LANG_CPP",
  LANG_CS: "IDM_LANG_CS",
  LANG_JAVA: "IDM_LANG_JAVA",
  LANG_HTML: "IDM_LANG_HTML",
  LANG_XML: "IDM_LANG_XML",
  LANG_JS: "IDM_LANG_JS",
  LANG_TS: "WEB_LANG_TYPESCRIPT",
  LANG_PHP: "IDM_LANG_PHP",
  LANG_PYTHON: "IDM_LANG_PYTHON",
  LANG_JSON: "IDM_LANG_JSON",
  LANG_YAML: "IDM_LANG_YAML",
  LANG_CSS: "IDM_LANG_CSS",
  LANG_SQL: "IDM_LANG_SQL",
  LANG_BASH: "IDM_LANG_BASH",
  LANG_POWERSHELL: "IDM_LANG_POWERSHELL",
  LANG_RUBY: "IDM_LANG_RUBY",
  LANG_GO: "IDM_LANG_GO",
  LANG_RUST: "IDM_LANG_RUST",
  LANG_R: "IDM_LANG_R",
  LANG_LUA: "IDM_LANG_LUA",
  LANG_PERL: "IDM_LANG_PERL",
  LANG_INI: "IDM_LANG_INI",
  LANG_MAKEFILE: "IDM_LANG_MAKEFILE",
  LANG_PROPS: "IDM_LANG_PROPS",
  LANG_MD: "WEB_LANG_MARKDOWN",
  LANG_TEX: "WEB_LANG_TEX",
  LANG_OEIS: "WEB_LANG_OEIS",
  LANG_MAX: "WEB_LANG_MAX",
  LANG_CSV: "WEB_LANG_CSV",
  LANG_EXCEL: "WEB_LANG_EXCEL",
  LANG_PDF: "WEB_LANG_PDF",
  LANG_DIFF: "WEB_LANG_DIFF",
  LANG_LINUXOBJ: "WEB_LANG_LINUXOBJ",
  LANG_STYLE_DLG: "IDM_LANGSTYLE_CONFIG_DLG",
  // Settings
  SETTING_PREF: "IDM_SETTING_PREFERENCE",
  SETTING_SHORTCUT: "IDM_SETTING_SHORTCUT_MAPPER",
  /** WEB: typography and line-break rules for Markdown preview. */
  SETTING_MARKDOWN_PREVIEW_STYLE: "WEB_SETTING_MARKDOWN_PREVIEW_STYLE",
  // Tools
  TOOL_MD5: "IDM_TOOL_MD5_GENERATE",
  TOOL_SHA256: "IDM_TOOL_SHA256_GENERATE",
  TOOL_BASE64_ENCODE: "WEB_TOOL_BASE64_ENCODE",
  TOOL_BASE64_DECODE: "WEB_TOOL_BASE64_DECODE",
  /** WEB: send selection to local Gemini backend; review suggestion before applying. */
  TOOL_GEMINI_BEAUTIFY_SELECTION: "WEB_TOOL_GEMINI_BEAUTIFY_SELECTION",
  // Macro
  MACRO_START: "IDM_MACRO_STARTRECORDINGMACRO",
  MACRO_STOP: "IDM_MACRO_STOPRECORDINGMACRO",
  MACRO_PLAY: "IDM_MACRO_PLAYBACKRECORDEDMACRO",
  // Run
  RUN_EXECUTE: "IDM_EXECUTE",
  // Window
  WINDOW_WINDOWS: "IDM_WINDOW_WINDOWS",
  /** WEB: reorder tab strip (active tab). */
  WINDOW_TAB_MOVE_LEFT: "WEB_WINDOW_TAB_MOVE_LEFT",
  WINDOW_TAB_MOVE_RIGHT: "WEB_WINDOW_TAB_MOVE_RIGHT",
  // Help
  HELP_ABOUT: "IDM_DEBUGINFO",
  HELP_CMDLINE: "IDM_CMDLINEARGUMENTS",
  /** WEB: show/copy this browser’s persistent NullaPad instance secret. */
  HELP_NULLAPAD_IDENTITY: "WEB_HELP_NULLAPAD_IDENTITY",
  /** WEB: scrollable story / product description (Markdown). */
  HELP_NULLAPAD_STORY: "WEB_HELP_NULLAPAD_STORY",
  /** WEB: full user guide (Markdown) shown in Help menu. */
  HELP_NULLAPAD_USERS_GUIDE: "WEB_HELP_NULLAPAD_USERS_GUIDE",
  /** WEB: MAX language guide (Markdown) shown in Help menu. */
  HELP_NULLAPAD_MAX_GUIDE: "WEB_HELP_NULLAPAD_MAX_GUIDE",
} as const;

/** MRU menu command ids in MRU order (index 0 = most recent). */
export const FILE_RECENT_SLOT_IDS = [
  CMD.FILE_RECENT_0,
  CMD.FILE_RECENT_1,
  CMD.FILE_RECENT_2,
  CMD.FILE_RECENT_3,
  CMD.FILE_RECENT_4,
  CMD.FILE_RECENT_5,
  CMD.FILE_RECENT_6,
  CMD.FILE_RECENT_7,
  CMD.FILE_RECENT_8,
  CMD.FILE_RECENT_9,
] as const;

export type CommandId = (typeof CMD)[keyof typeof CMD];
